import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { compose, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import logo from '../../../images/logo_rev.svg';
import { fullName } from '../../../services';
import { sessionActions } from '../../../state/modules/session';
import { currentUserSelector } from '../../../state/modules/user';
import { Icon } from '../../components';
import MenuItem from './mobile-nav-menu-item';

const PublisherNavMobile = ({
  logout,
  menuOpen,
  toggleMenu,
  closeMenu,
  userFullName
}) => (
    <div className={classNames({ 'hamburgler-active': menuOpen })}>
      <nav id='navigation--mobile'>
        <ul>
          <MenuItem label='Courses' route={routes.publisherPortal.courseDashboard} icon='caddie-links-large-alt' />
          <MenuItem label='Events' route={routes.publisherPortal.publishedEventDashboard} icon='event-large' />
          <MenuItem label='Content' route={routes.publisherPortal.content} icon='content-large' />
          <MenuItem label='Menu' icon='hamburger' onClick={toggleMenu} upperBadge />
        </ul>
      </nav>
      <div className='hamburgler-menu'>
        <header>
          <div className='logo'>
            <img src={logo} alt='Caddie' />
          </div>
          <div className='hamburgler-close' onClick={closeMenu}>
            <Icon icon='close' />
          </div>
        </header>
        <div className='hamburgler-menu-list'>
          <div className='loggedInAs'>Logged in as {userFullName}</div>
          <ul>
            <MenuItem
              label='Go to User Portal'
              icon='dashboard-large'
              route={routes.app.dashboard} />
            <MenuItem
              label='Support'
              icon='help-large'
              route={`mailto:support@thinkcaddie.com?subject=Caddie Support Request&cc=helpdesk@complii.com.au`}
              externalLink />
            <MenuItem label='Log out' icon='logout' onClick={(e) => logout()} />
          </ul>
        </div>
      </div>
    </div>
  );

const mapStateToProps = (state) => ({
  user: currentUserSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  logout: bindActionCreators(sessionActions.session.logout, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers({
    menuOpen: false
  }, {
      toggleMenu: ({ menuOpen }) => () => ({
        menuOpen: !menuOpen
      }),
      closeMenu: () => () => ({
        menuOpen: false
      })
    }),
  withProps(({ user }) => ({
    userFullName: fullName(user)
  }))
)(PublisherNavMobile);



// WEBPACK FOOTER //
// ./src/containers/partials/nav/publisher-nav-mobile.js